import React from "react";
import NoteTags from "./NoteTags";
import UserManagement from "./UserManagement";
import EmailBlacklist from "./EmailBlacklist";
import SettingsTabs from "../components/common/SwipeableViewTabs";

const Settings = () => (
  <>
    <h4>Settings</h4>
    <SettingsTabs viewNames={["User Management", "Note Tags", "Email Blacklist"]}>
      <UserManagement />
      <NoteTags />
      <EmailBlacklist />
    </SettingsTabs>
  </>
);

export default Settings;
